var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module"},[_c('div',{staticClass:"skeleton card row"},[_c('div',{staticClass:"content col pb-0"},[_c('div',{style:({ height: _vm.customHeight + 'em' })})]),_c('div',{staticClass:"content d-flex col py-0"},[_c('div',{staticClass:"box",style:({
                    width: _vm.customWidth + 'px',
                    height: _vm.customHeight + 'em'
                })}),_c('div',{staticClass:"box",style:({
                    width: _vm.customWidth + 'px',
                    height: _vm.customHeight + 'em'
                })}),_c('div',{staticClass:"box",style:({
                    width: _vm.customWidth + 'px',
                    height: _vm.customHeight + 'em'
                })})]),_c('div',{staticClass:"content col pb-0"},[_c('div',{style:({ height: _vm.customHeight + 'em' })})]),_c('div',{staticClass:"content d-flex col py-0"},[_c('div',{staticClass:"box",style:({
                    width: _vm.customWidth + 'px',
                    height: _vm.customHeight + 'em'
                })}),_c('div',{staticClass:"box",style:({
                    width: _vm.customWidth + 'px',
                    height: _vm.customHeight + 'em'
                })})])])])}
var staticRenderFns = []

export { render, staticRenderFns }